(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Recherche||Current search',
    noCollectionFound: 'Aucune collection trouvée||No collection found',
    allProducts: 'Voir tous les produits||See all products',
    matching: 'correspondant à||matching',
    sortBy: 'Trié par||Sorted by',
    relevance: 'Pertinence||Best match',
    outOf: 'out of||sur',
    resultsFound: 'résultats trouvés||results found',
    oneResultFound: '1 résultat trouvé||1 result found',
    noResultFound: 'Aucun résultat trouvé||No result found',
    addToCart: 'Ajouter au panier||Add to cart',
    searchForProduct: 'Rechercher des produits||Search for products',
    selectedFilter: 'Filtres sélectionnés||Selected filters',
    clearAll: 'Tout effacer||Clear all',
    noPageFound: 'Aucune page trouvée||No page found',
    outOfStock: 'Rupture de stock||Out of stock',
  };

  algolia.translation_helpers = {
    buildTranslationSpan: function(text, render) {
      const renderedText = render(text);
  
      return window.i18next.buildTextSpan(renderedText);
    },

    no_result_for: function(text, render) {
      return 'No result for query ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
